import type { InvoicePrintDocument } from "./invoice-print";

export const GOLDEN_INVOICE_PRINT_DOCUMENT: InvoicePrintDocument = {
  saleId: "00000000-0000-4000-8000-000000000101",
  invoiceNumber: "INV-2026-27-000042",
  acceptedAt: "2026-07-20T10:15:30.000Z",
  fiscalYear: "2026-27",
  store: {
    name: "MediCore Pharmacy",
    address: "12 Health Street",
    city: "Pune",
    state: "Maharashtra",
    pincode: "411001",
    phone: "020-40000000",
    whatsapp: "9876500000",
    email: "care@medicore.test",
    gstin: "27ABCDE1234F1Z5",
    drugLicense: "MH-PH-2026-42",
    fssaiLicense: "11526034000123",
  },
  customer: {
    name: "Anita Rao",
    phone: "9876543210",
    address: "Camp, Pune",
  },
  compliance: {
    patientName: "Anita Rao",
    doctorName: "Dr Meera Joshi",
    doctorRegistration: "MMC-12345",
    prescriptionNumber: "RX-2026-42",
    prescriptionDate: "2026-07-20",
  },
  cashierName: "Kiran Shah",
  items: [
    {
      lineId: "line-1",
      name: "Paracetamol 500 mg",
      sku: "PARA500",
      hsnCode: "30049099",
      manufacturer: "Health Labs",
      scheduleType: "GENERAL",
      quantity: "2.000000",
      freeQuantity: "0.000000",
      promotionalFreeQuantity: "0.000000",
      replacementQuantity: "0.000000",
      sampleQuantity: "0.000000",
      unitMrpPaise: 6000,
      unitPricePaise: 5600,
      gstBps: 500,
      grossPaise: 11200,
      discountPaise: 1000,
      taxablePaise: 9714,
      cgstPaise: 243,
      sgstPaise: 243,
      igstPaise: 0,
      taxPaise: 486,
      totalPaise: 10200,
      lots: [
        {
          batchNumber: "B2407A",
          expiryDate: "2028-06-30T00:00:00.000Z",
          quantity: "2.000000",
        },
      ],
    },
    {
      lineId: "line-2",
      name: "ORS Sachet",
      sku: "ORS01",
      hsnCode: "30049099",
      manufacturer: "Care Labs",
      scheduleType: "GENERAL",
      quantity: "1.000000",
      freeQuantity: "1.750000",
      promotionalFreeQuantity: "1.000000",
      replacementQuantity: "0.500000",
      sampleQuantity: "0.250000",
      unitMrpPaise: 2400,
      unitPricePaise: 2100,
      gstBps: 1200,
      grossPaise: 2100,
      discountPaise: 0,
      taxablePaise: 1875,
      cgstPaise: 113,
      sgstPaise: 112,
      igstPaise: 0,
      taxPaise: 225,
      totalPaise: 2100,
      lots: [
        {
          batchNumber: "ORS2601",
          expiryDate: "2027-12-31T00:00:00.000Z",
          quantity: "2.750000",
        },
      ],
    },
  ],
  charges: [
    {
      lineId: "charge-1",
      chargeCode: "PACKING_INCLUDED",
      name: "Packing",
      lineKind: "PACKING",
      quantity: "1.000000",
      uqc: "NOS",
      unitPricePaise: 0,
      gstBps: 0,
      grossPaise: 0,
      discountPaise: 0,
      taxablePaise: 0,
      cgstPaise: 0,
      sgstPaise: 0,
      igstPaise: 0,
      taxPaise: 0,
      settlementAdjustmentPaise: 0,
      totalPaise: 0,
      refundable: false,
      refundPolicy: { mode: "NON_REFUNDABLE" },
    },
  ],
  kits: [
    {
      lineId: "kit-1",
      kitCode: "HEALTH_COMBO",
      name: "Health Combo Pack",
      packIdentity: "MFR-COPACK-2026",
      kitBatchNumber: "KIT2607",
      kitExpiryDate: "2027-06-30T00:00:00.000Z",
      quantity: "1.000000",
      uqc: "PAC",
      printedMrpPaise: 5000,
      unitPricePaise: 0,
      gstBps: 0,
      grossPaise: 0,
      discountPaise: 0,
      taxablePaise: 0,
      cgstPaise: 0,
      sgstPaise: 0,
      igstPaise: 0,
      taxPaise: 0,
      settlementAdjustmentPaise: 0,
      totalPaise: 0,
      returnPolicy: { mode: "FULL_KIT_ONLY" },
      components: [
        {
          productId: "00000000-0000-4000-8000-000000000201",
          name: "Vitamin Tablets",
          quantity: "1.000000",
          lots: [
            {
              batchNumber: "VIT2601",
              expiryDate: "2027-06-30T00:00:00.000Z",
              quantity: "1.000000",
            },
          ],
        },
        {
          productId: "00000000-0000-4000-8000-000000000202",
          name: "Electrolyte Sachet",
          quantity: "2.000000",
          lots: [
            {
              batchNumber: "ELY2602",
              expiryDate: "2027-09-30T00:00:00.000Z",
              quantity: "2.000000",
            },
          ],
        },
      ],
    },
  ],
  totals: {
    subtotalPaise: 13300,
    discountPaise: 1000,
    taxablePaise: 11589,
    cgstPaise: 356,
    sgstPaise: 355,
    igstPaise: 0,
    taxPaise: 711,
    roundOffPaise: 0,
    payablePaise: 12300,
  },
  tenders: [
    { method: "CASH", amountPaise: 10000, reference: null },
    { method: "UPI", amountPaise: 2300, reference: "UPI-42" },
  ],
};

export const GOLDEN_INVOICE_EXPECTATIONS = {
  required80mm: [
    "TAX INVOICE",
    "INV-2026-27-000042",
    "Paracetamol 500 mg",
    "B2407A/2028-06 x2",
    "Paid 1 | Promo 1",
    "Replacement 0.5 | Sample 0.25",
    "Health Combo Pack (KIT)",
    "Vitamin Tablets x1",
    "Packing (PACKING)",
    "CGST",
    "SGST",
    "TOTAL                                 Rs. 123.00",
    "Tender CASH                           Rs. 100.00",
    "Tender UPI (UPI-42)                    Rs. 23.00",
  ],
  requiredA4: [
    "TAX INVOICE",
    "INV-2026-27-000042",
    "Paracetamol 500 mg",
    "B2407A / 2028-06",
    "Qty 1 + promo 1 + replacement 0.5 + sample 0.25",
    "Health Combo Pack",
    "Vitamin Tablets",
    "Packing",
    "₹ 123.00",
    "UPI-42",
  ],
  payablePaise: 12300,
};
